import gql from 'graphql-tag';
const PROCESS_MODEL_SCORE = gql`
  mutation processModelScore(
    $orgID: ID!
    $hashedEmailListId: ID!
    $audienceName: String
  ) {
    processModelScore(
      data: { orgID: $orgID, hashedEmailListId: $hashedEmailListId, audienceName: $audienceName }
    )
  }
`;

export default PROCESS_MODEL_SCORE;
